import React from "react";
import "../Navigation/css/NavBar.scss";

export default function Terminology() {
    return (
        <div>
            Terminology
        </div>
    )
}